import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type TabState = {
  tabs: string[]
  active: string | null
  /** Last collection sub-tab the user was on (posts/replies/likes/.../gallery) */
  lastTab: string
  open: (handle: string) => void
  close: (handle: string) => string | null
  setActive: (handle: string | null) => void
  setLastTab: (t: string) => void
  clear: () => void
}

export const useTabs = create<TabState>()(
  persist(
    (set, get) => ({
      tabs: [],
      active: null,
      lastTab: 'posts',
      setLastTab: (lastTab) => {
        if (!lastTab) return
        if (get().lastTab !== lastTab) set({ lastTab })
      },
      open: (handle) => {
        const h = handle.trim().toLowerCase()
        if (!h) return
        const t = get().tabs
        if (t.includes(h)) {
          if (get().active !== h) set({ active: h })
          return
        }
        set({ tabs: [...t, h], active: h })
      },
      close: (handle) => {
        const h = handle.trim().toLowerCase()
        const t = get().tabs
        const idx = t.indexOf(h)
        if (idx === -1) return get().active
        const next = t.filter((x) => x !== h)
        let nextActive: string | null = get().active
        if (nextActive === h) {
          nextActive = next[idx] ?? next[idx - 1] ?? null
        } else if (!next.includes(nextActive ?? '')) {
          nextActive = next[next.length - 1] ?? null
        }
        set({ tabs: next, active: nextActive })
        return nextActive
      },
      setActive: (handle) => set({ active: handle ? handle.toLowerCase() : null }),
      clear: () => set({ tabs: [], active: null }),
    }),
    { name: 'bskydisc.tabs' },
  ),
)
